import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252bda6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup__title" }, "Check your device compatibility", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup__description" }, [
  /*#__PURE__*/_createTextVNode(" if your device is not listed you will not be able to install an eSIM. Unsure of your device model? Find out by clicking "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://toosim.com/esim-compatible",
    target: "_blank"
  }, "here")
], -1))
const _hoisted_3 = { class: "button-toggle-group" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "device-list"
}

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useDataStore } from "@/stores/data";
import { ref, Ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupDevices',
  setup(__props) {

const dataStore = useDataStore();
const activeDevice: Ref<number> = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, { class: "device-popup" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataStore).supportedDevices, (device, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: _normalizeClass(["button-toggle", { active: activeDevice.value === index }]),
            onClick: ($event: any) => (activeDevice.value = index)
          }, _toDisplayString(device.name), 11, _hoisted_4))
        }), 128))
      ]),
      (_unref(dataStore).supportedDevices.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataStore).supportedDevices[activeDevice.value]
          .models, (model, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "device"
              }, _toDisplayString(model), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})